import { associations, attributes, IAssociations, IAttributes } from 'app/constants/schemas/mediaList';
import vmClient from 'app/services/vmClient';
import { Entity, EntityStringId, IEntity, IEntityType } from 'app/types/entity';

export interface IMediaGroup extends IEntity {
  attributes: IAttributes & {
    id: EntityStringId;
  };
  associations: IAssociations;
}

export type MediaGroup = Entity<IMediaGroup>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaGroup: IEntityType<IMediaGroup> = vmClient.defineClass({
  typeName: 'MediaGroup',
  version: 1,
  persisted: true,
  attributes,
  associations,
});
